<template>
  <div class="min-h-screen bg-dark-200">
    <!-- Global Loading Indicator -->
    <div
      v-if="isLoading"
      class="fixed inset-0 bg-dark-200 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
    </div>

    <!-- Main Content -->
    <router-view v-slot="{ Component }">
      <transition
        name="fade"
        mode="out-in"
        @before-leave="isLoading = true"
        @after-enter="isLoading = false"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import './assets/main.css'

const isLoading = ref(false)
</script>
